import {
  FacetEnrichments,
  FacetValueEnrichment,
} from "@repo/apis/browse-facet-v1";
import { Facet, FacetValue } from "@repo/apis/browse-search-v2";

export type EnrichedFacetValue = FacetValue & {
  enrichment?: FacetValueEnrichment;
};

export type EnrichedFacet = Facet & {
  facetValues: EnrichedFacetValue[];
};

type EnrichmentLookup = Record<string, Record<string, FacetValueEnrichment>>;

const createEnrichmentLookup = (
  enrichments: FacetEnrichments,
): EnrichmentLookup => {
  return enrichments.items.reduce((acc, enrichment) => {
    acc[enrichment.facetId] = enrichment.facetValues.reduce(
      (valueAcc, value) => {
        valueAcc[value.facetValueId] = value.enrichment;
        return valueAcc;
      },
      {} as Record<string, FacetValueEnrichment>,
    );
    return acc;
  }, {} as EnrichmentLookup);
};

export const enrichFacets = (
  facets: Facet[],
  enrichments: FacetEnrichments,
): EnrichedFacet[] => {
  const enrichmentLookup = createEnrichmentLookup(enrichments);

  return facets.map((facet) => {
    const facetEnrichments = enrichmentLookup[facet.id];
    if (!facetEnrichments) return facet;

    return {
      ...facet,
      facetValues: facet.facetValues.map((value) => ({
        ...value,
        enrichment: facetEnrichments[value.id],
      })),
    };
  });
};
